import NotFoundPage from './pages/404-page';
import MapPage from './pages/map-page';
import SharePage from './pages/share-page';

export const ROUTES_ID = {
  MAP: 'map-page',
  NOT_FOUND: '404-page',
  SHARE: 'share-page',
};

const routes = [
  {
    component: SharePage,
    exact: true,
    id: ROUTES_ID.SHARE,
    path: ['/share/:userid/:lat?/:lng?/:zoom?'],
  },
  {
    component: MapPage,
    exact: true,
    id: ROUTES_ID.MAP,
    path: ['/', '/:lat/:lng/:zoom'],
  },
  {
    component: NotFoundPage,
    exact: true,
    id: ROUTES_ID.NOT_FOUND,
    path: ['*'],
  },
];

export default routes;
